export enum SchduleInputErrors {
  Start_Time_Less_Than_Current_Time = 'Start time should be greater than current time',
  Start_Time_Less_Than_End_Time = 'Start time should be less than end time',
  End_Time_Greater_Than_Start_Time = 'End time should be greater than start time'
}
